import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { BookingsListResponse } from "@/models/api/bookings/BookingsList";
import { axiosInstance } from "@/plugins/axios";
import { BookingSelectResponse } from "@/models/api/bookings/BookingSelectResponse";
import { BookingGetTemporaryContractorsResponse } from "@/models/api/bookings/BookingGetTemporaryContractorsResponse";
import { BookingGetTemporaryResponse } from "@/models/api/bookings/BookingGetTemporaryResponse";
import {
  AttributeItem,
  BookingGetTemporaryItemResponse,
  TradeTermItem,
} from "@/models/api/bookings/BookingGetTemporaryItem";
import BaseCommand from "@/models/api/commands/BaseCommand";
import { OperationResult } from "@/models/api/orders/OperationResult";
import { TemporaryFileId, TemporaryFileResponse } from "@/models/api/bookings/TemporaryFile";
import {
  BookingItemStatusCheck,
  BookingStatusCheck,
  StatusCheckPartial,
} from "@/models/api/bookings/BookingStatusCheck";
import { VOUCHER_TYPE } from "@/static/voucherTypes";
import { FileTmp } from "@/models/api/Files";
import { FILTER_NAMES } from "@/static/filterNames";
import { BookingDetails, BookingItemDetails } from "@/models/api/bookings/BookingDetails";
import { GroupBookingItems } from "@/models/api/bookings/GroupBookingItems";
import { GetBookingFilesResponse } from "@/models/api/bookings/BookingFilesListItem";
import { TouristContract } from "@/models/api/bookings/TouristContract";
import { OfficeProfileFormOfPayment } from "@/models/api/administration/offices/OfficeProfileFormOfPayment";
import AgentCreditCard from "@/models/api/bookings/AgentCreditCard";
import { ContractorMonit } from "@/models/api/bookings/ContractorMonit";
import { SplitBooking } from "@/models/api/bookings/SplitBooking";
import { CancelBookingItem } from "@/models/api/bookings/CancelBookingItem";

//#region Routes
export const URL_GET_BOOKINGS_PAGED = "/Booking/Paged";
export const URL_GET_BOOKING_TEMPORARY_ATTRIBUTES =
  "/Booking/${OperationId}/TemporaryBookingItemAttributes/${BookingItemTmpId}";
export const URL_GET_BOOKING_TEMPORARY_TRADE_TERMS =
  "/Booking/${OperationId}/TemporaryBookingItemTradeTerms/${BookingItemTmpId}";
export const URL_POST_TOGGLE_SELECT_BOOKING = "/Booking/${BookingId}/ToggleSelect";
export const URL_POST_TOGGLE_SELECT_BOOKING_ITEM = "/Booking/BookingItem/${BookingItemId}/ToggleSelect";
export const URL_POST_SET_BOOKING_SELECTION_STATE = "/Booking/${BookingId}/SetBookingSelectionState";
export const URL_POST_CHANGE_BOOKING_ITEM_STATUS =
  "/Booking/BookingItem/${BookingItemId}/ChangeBookingItemStatus/${Status}";
export const URL_POST_CHANGE_HAS_COST_DOCUMENT =
  "/Booking/BookingItem/${BookingItemId}/ChangeBookingItemHasCostDocument";
export const URL_POST_UNLOCK_BOOKING_ITEM_TO_INVOICE = "/Booking/BookingItem/${BookingItemId}/UnlockToInvoice";
export const URL_POST_EDIT_BOOKING = "/Booking/${BookingId}/EditBooking";
export const URL_POST_PREVIEW_BOOKING = "/Booking/${BookingId}/PreviewBooking";
export const URL_POST_NEW_BOOKING = "/Booking/NewBooking";
export const URL_GET_BOOKING_TEMPORARY_CONTRACTORS = "/Booking/${OperationId}/TemporaryContractors";
export const URL_GET_BOOKING_TEMPORARY = "/Booking/${OperationId}/TemporaryBooking";
export const URL_GET_BOOKING_TEMPORARY_ITEM = "/Booking/${OperationId}/TemporaryBookingItem/${BookingItemTmpId}";
export const URL_GET_BOOKING_TEMPORARY_FILE = "/Booking/${OperationId}/TemporaryFile";
export const URL_GET_BOOKING_TEMPORARY_FILE_DATA = "/Booking/${OperationId}/TemporaryFileData/${FileTmpId}";
export const URL_POST_BOOKING_SAVE = "/Booking/${OperationId}/SaveBooking";
export const ULR_POST_BOOKING_TEMPORARY_UPDATE = "/Booking/UpdateBookingTemporary";
export const ULR_POST_UPLOAD_BOOKING_TEMPORARY_FILE = "/Booking/${OperationId}/UploadTemporaryFile/${Type}";
export const ULR_GET_BOOKING_ITEM_AVAILABLE_STATUS = "/Booking/${OperationId}/AvailableStatus/${BookingItemTmpId}";
export const ULR_GET_BOOKING_AVAILABLE_STATUS = "/Booking/${OperationId}/AvailableStatus";
export const ULR_POST_BOOKING_CREATE_VOUCHER = "/Booking/${OperationId}/CreateVoucher/${VoucherType}";
export const ULR_POST_BOOKING_CREATE_TOURIST_CONTRACT = "/Booking/CreateTouristContract";
export const URL_POST_UNSELECT_ALL_BOOKINGS = "/Booking/UnselectAll";
export const URL_GET_SELECTED_BOOKING_ITEMS_FIRST_NUMBERS = "/Booking/SelectedBookingsFirstNumbers";
export const URL_POST_CANCEL_SELECTED_BOOKING_ITEMS = "/Booking/CancelSelectedBookingItems";
export const URL_POST_CANCEL_BOOKING_ITEMS = "/Booking/CancelBookingItem";
export const URL_POST_UPLOAD_BOOKING_PARSE_FILE = "/File/${SessionId}/UploadBookingParseFile";
export const URL_POST_PROCESS_SPARK_PACKAGE = "/Booking/ProcessSparkPackage";
export const URL_GET_BOOKING_PDF_PACKAGE = "/Booking/GenerateBookingPdfPackage";
export const URL_GET_GENERATE_BOOKING_RECORD_LOCATOR = "/Booking/GenerateRecordLocator";
export const URL_POST_CLONE_BOOKING = "/Booking/${BookingId}/Clone/${RecordLocator}";
export const URL_POST_CLONE_BOOKING_ITEM = "/Booking/${BookingItemId}/CloneItem";
export const URL_GET_BOOKING_DETAILS = "/Booking/${BookingId}/Details";
export const URL_GET_BOOKING_ITEM_GROUP_TO_EDIT = "/Booking/GetBookingItemGroupToEdit";
export const URL_POST_SAVE_BOOKING_ITEM_GROUP = "/Booking/SaveBookingItemGroup";
export const URL_GET_ADD_BOOKING_ITEM_TO_EXIST_GROUP = "/Booking/AddBookingItemToExistGroup";
export const URL_GET_REMOVE_BOOKING_ITEM_FROM_GROUP = "/Booking/RemoveBookingItemFromGroup";
export const URL_GET_BOOKING_FILES = "/Booking/BookingFiles";
export const URL_POST_PARSE_LOADED_BOOKING_FILES = "/Booking/ParseLoadedBookingFiles";
export const URL_POST_PARSE_BOOKING_FILE = "/Booking/ParseBookingFile";
export const URL_GET_PREVIEW_BOOKING_FILE = "/Booking/ShowBookingFile";
export const URL_POST_CHECK_EXPORT_ORDER_BETWEEN_OFFICE = "/Booking/${OperationId}/CheckExportOrder";
export const URL_GET_BOOKING_EDITOR_FORMS_OF_PAYMENT = "/Office/FormsOfPayment/Booking/${ServiceTypeCode}/${GDSId}";
export const URL_GET_AGENT_CREDIT_CARDS = "/CreditCard/Agent/${UserId}";
export const URL_GET_TEMPORARY_CONTRACTOR_BOOKING_MONIT = "/Booking/${OperationId}/TemporaryContractorBookingMonit";
export const URL_GET_RECORD_LOCATOR_FOR_SPLITTED_BOOKING = "/Booking/GetRecordLocatorForSplittedBooking";
export const URL_POST_SPLIT_BOOKING = "/Booking/SplitBooking";
//#endregion

const _getBookingsTable = new CancellableHelper<BookingsListResponse>(URL_GET_BOOKINGS_PAGED, BookingsListResponse);
_getBookingsTable.jsonSerializer = true;
export const getBookingsTable = async (genericTableRequest: GenericTableRequest): Promise<BookingsListResponse> => {
  return await _getBookingsTable.get(genericTableRequest);
};

export const toggleSelectBooking = async (bookingId: number): Promise<BookingSelectResponse> => {
  const response = await axiosInstance.post(URL_POST_TOGGLE_SELECT_BOOKING, {}, { params: { BookingId: bookingId } });
  return response.data;
};

export const toggleSelectBookingItem = async (bookingItemId: number): Promise<BookingSelectResponse> => {
  const response = await axiosInstance.post(
    URL_POST_TOGGLE_SELECT_BOOKING_ITEM,
    {},
    { params: { BookingItemId: bookingItemId } }
  );
  return response.data;
};

export const setBookingSelectionState = async (bookingId: number, state: boolean): Promise<void> => {
  await axiosInstance.post(
    URL_POST_SET_BOOKING_SELECTION_STATE,
    {},
    {
      params: {
        BookingId: bookingId,
        State: state,
      },
    }
  );
};

const _changeBookingItemStatus = new CancellableHelper<null>(URL_POST_CHANGE_BOOKING_ITEM_STATUS, null, true);
export const changeBookingItemStatus = async (bookingItemId: number, status: number): Promise<null> => {
  return await _changeBookingItemStatus.post({
    BookingItemId: bookingItemId,
    Status: status,
  });
};

const _changeHasCostDocument = new CancellableHelper<null>(URL_POST_CHANGE_HAS_COST_DOCUMENT, null, true);
export const changeHasCostDocument = async (bookingItemId: number, hasCostDocument: boolean): Promise<null> => {
  return await _changeHasCostDocument.post({
    BookingItemId: bookingItemId,
    HasCostDocument: hasCostDocument,
  });
};

const _unlockBookingItemToInvoice = new CancellableHelper<null>(URL_POST_UNLOCK_BOOKING_ITEM_TO_INVOICE, null, true);
export const unlockBookingItemToInvoice = async (bookingItemId: number): Promise<null> => {
  return await _unlockBookingItemToInvoice.post({
    BookingItemId: bookingItemId,
  });
};

const _postUnselectAllBookings = new CancellableHelper<null>(URL_POST_UNSELECT_ALL_BOOKINGS, null, true);
export const postUnselectAllBookings = async (): Promise<null> => {
  return await _postUnselectAllBookings.post();
};

const _postEditBooking = new CancellableHelper<string>(URL_POST_EDIT_BOOKING);
export const editBooking = async (bookingId: number): Promise<string | undefined> => {
  return await _postEditBooking.post({ BookingId: bookingId });
};

const _postNewBooking = new CancellableHelper<string>(URL_POST_NEW_BOOKING);
export const newBooking = async (): Promise<string | undefined> => {
  return await _postNewBooking.post();
};

const _postPreviewBooking = new CancellableHelper<string>(URL_POST_PREVIEW_BOOKING);
export const previewBooking = async (bookingId: number): Promise<string | undefined> => {
  return await _postPreviewBooking.post({ BookingId: bookingId });
};

const _createTouristContract = new CancellableHelper<string>(ULR_POST_BOOKING_CREATE_TOURIST_CONTRACT, "string");
export const createTouristContract = async (touristContract: TouristContract): Promise<string> => {
  return await _createTouristContract.post({ TouristContract: touristContract }, null);
};

const _getBookingTemporaryContractors = new CancellableHelper<BookingGetTemporaryContractorsResponse>(
  URL_GET_BOOKING_TEMPORARY_CONTRACTORS,
  BookingGetTemporaryContractorsResponse,
  true
);
export const getBookingTemporaryContractors = async (
  operationId: string
): Promise<BookingGetTemporaryContractorsResponse> => {
  return await _getBookingTemporaryContractors.get({
    OperationId: operationId,
  });
};

const _getBookingTemporary = new CancellableHelper<BookingGetTemporaryResponse>(
  URL_GET_BOOKING_TEMPORARY,
  BookingGetTemporaryResponse
);
export const getBookingTemporary = async (operationId: string): Promise<BookingGetTemporaryResponse> => {
  return await _getBookingTemporary.get({
    OperationId: operationId,
  });
};

const _getBookingTemporaryItem = new CancellableHelper<BookingGetTemporaryItemResponse>(
  URL_GET_BOOKING_TEMPORARY_ITEM,
  BookingGetTemporaryItemResponse
);
export const getBookingTemporaryItem = async (
  operationId: string,
  bookingItemTmpId: string | null
): Promise<BookingGetTemporaryItemResponse> => {
  return await _getBookingTemporaryItem.get({
    OperationId: operationId,
    BookingItemTmpId: bookingItemTmpId,
  });
};

const _getBookingTemporaryItemAttributes = new CancellableHelper<Array<AttributeItem>>(
  URL_GET_BOOKING_TEMPORARY_ATTRIBUTES,
  AttributeItem
);
export const getBookingTemporaryItemAttributes = async (
  operationId: string,
  bookingItemTmpId: string | null
): Promise<Array<AttributeItem>> => {
  return await _getBookingTemporaryItemAttributes.get({
    OperationId: operationId,
    BookingItemTmpId: bookingItemTmpId,
  });
};

const _getBookingTemporaryItemTradeTerms = new CancellableHelper<Array<TradeTermItem>>(
  URL_GET_BOOKING_TEMPORARY_TRADE_TERMS,
  TradeTermItem
);
export const getBookingTemporaryItemTradeTerms = async (
  operationId: string,
  bookingItemTmpId: string | null
): Promise<Array<TradeTermItem>> => {
  return await _getBookingTemporaryItemTradeTerms.get({
    OperationId: operationId,
    BookingItemTmpId: bookingItemTmpId,
  });
};

const _getTemporaryFile = new CancellableHelper<TemporaryFileResponse>(URL_GET_BOOKING_TEMPORARY_FILE, TemporaryFileId);
export const getTemporaryFile = async (operationId: string): Promise<TemporaryFileResponse> => {
  return await _getTemporaryFile.get({
    OperationId: operationId,
  });
};

const _getTemporaryFileData = new CancellableHelper<TemporaryFileResponse>(
  URL_GET_BOOKING_TEMPORARY_FILE_DATA,
  TemporaryFileId
);
export const getTemporaryFileData = async (
  operationId: string,
  fileTmpId: string | null
): Promise<TemporaryFileResponse> => {
  return await _getTemporaryFileData.get({
    OperationId: operationId,
    FileTmpId: fileTmpId,
  });
};

const _postBookingSave = new CancellableHelper<number>(URL_POST_BOOKING_SAVE);
export const postBookingSave = async (operationId: string): Promise<number> => {
  return await _postBookingSave.post({
    OperationId: operationId,
  });
};

const _postUpdateBookingTemporary = new CancellableHelper<OperationResult>(
  ULR_POST_BOOKING_TEMPORARY_UPDATE,
  OperationResult
);
export const postUpdateBookingTemporary = async (command: BaseCommand): Promise<OperationResult> => {
  return await _postUpdateBookingTemporary.post(command);
};

export const postUploadTemporaryFile = async (
  operationId: string,
  type: number,
  files: Array<File>
): Promise<OperationResult> => {
  const url = ULR_POST_UPLOAD_BOOKING_TEMPORARY_FILE.replace("${OperationId}", operationId).replace(
    "${Type}",
    type.toString()
  );
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  const response = await axiosInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as OperationResult;
};

const _getBookingItemAvailableStatus = new CancellableHelper<BookingItemStatusCheck>(
  ULR_GET_BOOKING_ITEM_AVAILABLE_STATUS,
  BookingItemStatusCheck
);
export const getBookingItemAvailableStatus = async (
  operationId: string,
  bookingItemTmpId: string
): Promise<BookingItemStatusCheck> => {
  return await _getBookingItemAvailableStatus.get({
    OperationId: operationId,
    BookingItemTmpId: bookingItemTmpId,
  });
};

const _getBookingAvailableStatus = new CancellableHelper<BookingStatusCheck>(
  ULR_GET_BOOKING_AVAILABLE_STATUS,
  StatusCheckPartial
);
export const getBookingAvailableStatus = async (operationId: string): Promise<BookingStatusCheck> => {
  return await _getBookingAvailableStatus.get({
    OperationId: operationId,
  });
};

const _postCreateBookingVoucher = new CancellableHelper<Array<number>>(ULR_POST_BOOKING_CREATE_VOUCHER);
export const postCreateBookingVoucher = async (
  operationId: string,
  voucherType: VOUCHER_TYPE,
  tmpId: string | null = null
): Promise<Array<number>> => {
  return await _postCreateBookingVoucher.post(
    {
      OperationId: operationId,
      VoucherType: voucherType,
    },
    tmpId
  );
};

const _getSelectedBookingItemsFirstNumbers = new CancellableHelper<Array<string>>(
  URL_GET_SELECTED_BOOKING_ITEMS_FIRST_NUMBERS
);
export const getSelectedBookingItemsFirstNumbers = async (): Promise<Array<string>> => {
  return await _getSelectedBookingItemsFirstNumbers.get();
};

const _postCancelSelectedBookingItems = new CancellableHelper<null>(URL_POST_CANCEL_SELECTED_BOOKING_ITEMS, null, true);
export const postCancelSelectedBookingItems = async (model: CancelBookingItem): Promise<null> => {
  return await _postCancelSelectedBookingItems.post(null, model);
};

const _postCancelBookingItem = new CancellableHelper<null>(URL_POST_CANCEL_BOOKING_ITEMS, null, true);
export const postCancelBookingItem = async (model: CancelBookingItem): Promise<null> => {
  return await _postCancelBookingItem.post(null, model);
};

export const postUploadBookingParseFile = async (files: Array<File>, sessionId: string): Promise<Array<FileTmp>> => {
  const url = URL_POST_UPLOAD_BOOKING_PARSE_FILE.replace("${SessionId}", sessionId);
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  const response = await axiosInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as Array<FileTmp>;
};

export const postProcessSparkPackage = async (sessionId: string, internalAutoInvoice: boolean): Promise<null> => {
  const _postProcessSparkPackage = new CancellableHelper<null>(URL_POST_PROCESS_SPARK_PACKAGE, null, true);
  return _postProcessSparkPackage.post({ sessionId, internalAutoInvoice });
};

const _getBookingPdfPackage = new CancellableHelper<File>(URL_GET_BOOKING_PDF_PACKAGE, undefined, true);
_getBookingPdfPackage.jsonSerializer = true;
_getBookingPdfPackage.requestConfig = { responseType: "blob" };
export const getBookingPdfPackage = async (filter: unknown): Promise<null> => {
  const response: File = await _getBookingPdfPackage.get({
    criterions: filter,
    filterName: FILTER_NAMES.BookingDownloadPdfFilter,
    page: 1,
    count: 100000,
  } as GenericTableRequest);
  // fileDownload(response, response.name, response.type, true);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(response);
  link.download = response.name;
  // console.log;
  // link.target = "_blank";
  link.click();
  // console.log(response);
  // console.log(response);
  return null;
};

const _generateBookingRecordLocator = new CancellableHelper<string>(URL_GET_GENERATE_BOOKING_RECORD_LOCATOR);
export const generateBookingRecordLocator = async (): Promise<string> => {
  return await _generateBookingRecordLocator.get();
};

const _cloneBooking = new CancellableHelper<string>(URL_POST_CLONE_BOOKING);
export const cloneBooking = async (bookingId: number, recordLocator: string): Promise<string> => {
  return await _cloneBooking.post({
    RecordLocator: recordLocator,
    BookingId: bookingId,
  });
};

const _cloneBookingItem = new CancellableHelper<void>(URL_POST_CLONE_BOOKING_ITEM, null, true);
export const cloneBookingItem = async (bookingItemId: number, isClone: boolean): Promise<void> => {
  return await _cloneBookingItem.post({
    BookingItemId: bookingItemId,
    IsClone: isClone,
  });
};

const _getBookingItemGroupToEdit = new CancellableHelper<GroupBookingItems>(
  URL_GET_BOOKING_ITEM_GROUP_TO_EDIT,
  GroupBookingItems
);
export const getBookingItemGroupToEdit = async (
  bookingItemId: number,
  groupId: number | null
): Promise<GroupBookingItems> => {
  return await _getBookingItemGroupToEdit.get({
    BookingItemId: bookingItemId,
    GroupId: groupId,
  });
};

const _saveBookingItemGroup = new CancellableHelper<null>(URL_POST_SAVE_BOOKING_ITEM_GROUP, null, true);
export const saveBookingItemGroup = async (
  groupId: number | null,
  comment: string,
  bookingItemIds: Array<number>
): Promise<null> => {
  return await _saveBookingItemGroup.post({
    Id: groupId,
    Comment: comment,
    BookingItemIds: bookingItemIds,
  });
};

const _addBookingItemToExistGroup = new CancellableHelper<null>(URL_GET_ADD_BOOKING_ITEM_TO_EXIST_GROUP, null, true);
export const addBookingItemToExistGroup = async (bookingItemId: number, groupId: number | null): Promise<null> => {
  return await _addBookingItemToExistGroup.get({
    BookingItemId: bookingItemId,
    GroupId: groupId,
  });
};

const _removeBookingItemFromGroup = new CancellableHelper<null>(URL_GET_REMOVE_BOOKING_ITEM_FROM_GROUP, null, true);
export const removeBookingItemFromGroup = async (bookingItemId: number, groupId: number | null): Promise<null> => {
  return await _removeBookingItemFromGroup.get({
    BookingItemId: bookingItemId,
    GroupId: groupId,
  });
};

const _getBookingDetails = new CancellableHelper<BookingDetails>(URL_GET_BOOKING_DETAILS, BookingItemDetails);
export const getBookingDetails = async (bookingId: number): Promise<BookingDetails> => {
  return await _getBookingDetails.get({ BookingId: bookingId });
};

const _getBookingFiles = new CancellableHelper<GetBookingFilesResponse>(URL_GET_BOOKING_FILES, GetBookingFilesResponse);
_getBookingFiles.jsonSerializer = true;
export const getBookingFiles = async (genericTableRequest: GenericTableRequest): Promise<GetBookingFilesResponse> => {
  return await _getBookingFiles.get(genericTableRequest);
};

const _postParseLoadedBookingFiles = new CancellableHelper<null>(URL_POST_PARSE_LOADED_BOOKING_FILES, null, true);
_postParseLoadedBookingFiles.requestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};
export const postParseLoadedBookingFiles = async (files: Array<File>, filesType: string) => {
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  await _postParseLoadedBookingFiles.post({ filesType: filesType }, formData);
};

const _postParseBookingFile = new CancellableHelper<null>(URL_POST_PARSE_BOOKING_FILE, null, true);
export const postParseBookingFile = async (bookingDataId: number) => {
  await _postParseBookingFile.post({ bookingDataId: bookingDataId });
};

const _getPreviewBookingFile = new CancellableHelper<string>(URL_GET_PREVIEW_BOOKING_FILE);
export const getPreviewBookingFile = async (bookingDataId: number): Promise<string> => {
  return await _getPreviewBookingFile.get({ bookingDataId: bookingDataId });
};

const _postCheckExportOrderBetweenOffice = new CancellableHelper<boolean>(URL_POST_CHECK_EXPORT_ORDER_BETWEEN_OFFICE);
export const postCheckExportOrderBetweenOffice = async (operationId: string): Promise<boolean> => {
  return await _postCheckExportOrderBetweenOffice.get({
    OperationId: operationId,
  });
};

const _getFormOfPayments = new CancellableHelper<Array<OfficeProfileFormOfPayment>>(
  URL_GET_BOOKING_EDITOR_FORMS_OF_PAYMENT
);
export const getFormOfPayments = async (
  serviceTypeCode: string | null,
  gdsId: number | null
): Promise<Array<OfficeProfileFormOfPayment>> => {
  return await _getFormOfPayments.get({ ServiceTypeCode: serviceTypeCode, GDSId: gdsId });
};

const _getAgentCreditCards = new CancellableHelper<Array<AgentCreditCard>>(URL_GET_AGENT_CREDIT_CARDS);
export const getAgentCreditCards = async (userId: string | null): Promise<Array<AgentCreditCard>> => {
  return await _getAgentCreditCards.get({ UserId: userId });
};

const _getTemporaryContractorBookingMonit = new CancellableHelper<Array<ContractorMonit>>(
  URL_GET_TEMPORARY_CONTRACTOR_BOOKING_MONIT
);
export const getTemporaryContractorBookingMonit = (operationId: string): Promise<Array<ContractorMonit>> => {
  return _getTemporaryContractorBookingMonit.get({
    OperationId: operationId,
  });
};

const _getRecordLocatorForSplittedBooking = new CancellableHelper<string>(URL_GET_RECORD_LOCATOR_FOR_SPLITTED_BOOKING);
export const getRecordLocatorForSplittedBooking = async (recordLocator: string): Promise<string> => {
  return await _getRecordLocatorForSplittedBooking.get({ recordLocator: recordLocator });
};

const _postSplitBooking = new CancellableHelper<null>(URL_POST_SPLIT_BOOKING, null, true);
export const postSplitBooking = async (model: SplitBooking): Promise<null> => {
  return await _postSplitBooking.post(null, model);
};
